var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.1 512.1",
    style: {
      enableBackground: "new 0 0 512.1 512.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M503.5,373.95h-468c-4.7,0-8.5-3.8-8.5-8.5V64.65c0-4.7,3.8-8.5,8.5-8.5h468.1c4.7,0,8.5,3.8,8.5,8.5 v300.8C512,370.15,508.2,373.95,503.5,373.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M265.2,100.65L88.9,207.95c-5.3,3.3-5.3,11,0,14.3l176.3,107.3c2.7,1.6,6,1.6,8.7,0l176.3-107.3 c5.3-3.3,5.3-11,0-14.3l-176.3-107.3C271.2,98.95,267.8,98.95,265.2,100.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M336.4,212.85c1.2,38.7-30.4,70.3-69.1,69.1c-35-1.1-63.5-29.7-64.6-64.6 c-1.2-38.7,30.4-70.3,69.1-69.1C306.7,149.35,335.3,177.85,336.4,212.85z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M212.1,180.85c-3.1,5.3-5.6,11-7.2,17.1c37.1-2.8,91.9,7.6,126.8,41.5c2.2-5.8,3.8-12,4.4-18.5 C300.1,190.55,250.2,179.85,212.1,180.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M272.3,237.95l1.8,5.3l5.6,0.1c0.7,0,1,1,0.4,1.3l-4.6,3.3l1.7,5.4c0.2,0.7-0.6,1.3-1.2,0.8 l-4.6-3.3l-4.6,3.3c-0.6,0.4-1.4-0.1-1.2-0.8l1.7-5.4l-4.6-3.3c-0.6-0.4-0.3-1.3,0.4-1.3l5.6-0.1l1.8-5.3 C271.1,237.15,272.1,237.15,272.3,237.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M294.1,251.75l0.8,2.3h2.4c0.3,0,0.4,0.4,0.2,0.6l-1.9,1.4l0.7,2.3c0.1,0.3-0.3,0.6-0.5,0.4l-2-1.4 l-2,1.4c-0.3,0.2-0.6-0.1-0.5-0.4l0.7-2.3l-1.9-1.4c-0.3-0.2-0.1-0.6,0.2-0.6h2.4l0.8-2.3C293.6,251.35,294.1,251.35,294.1,251.75z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M262.8,227.75l0.8,2.3h2.4c0.3,0,0.4,0.4,0.2,0.6l-1.9,1.4l0.7,2.3c0.1,0.3-0.3,0.6-0.5,0.4l-2-1.4 l-2,1.4c-0.3,0.2-0.6-0.1-0.5-0.4l0.7-2.3l-1.9-1.4c-0.3-0.2-0.1-0.6,0.2-0.6h2.4l0.8-2.3C262.3,227.45,262.8,227.45,262.8,227.75z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.4,224.95l0.8,2.3h2.4c0.3,0,0.4,0.4,0.2,0.6l-1.9,1.4l0.7,2.3c0.1,0.3-0.3,0.6-0.5,0.4l-2-1.4 l-2,1.4c-0.3,0.2-0.6-0.1-0.5-0.4l0.7-2.3l-1.9-1.4c-0.3-0.2-0.1-0.6,0.2-0.6h2.4l0.8-2.3C219.9,224.65,220.3,224.65,220.4,224.95z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M255.9,250.85l0.8,2.3h2.4c0.3,0,0.4,0.4,0.2,0.6l-1.9,1.4l0.7,2.3c0.1,0.3-0.3,0.6-0.5,0.4l-2-1.4 l-2,1.4c-0.3,0.2-0.6-0.1-0.5-0.4l0.7-2.3l-1.9-1.4c-0.3-0.2-0.1-0.6,0.2-0.6h2.4l0.8-2.3C255.4,250.65,255.8,250.65,255.9,250.85z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.4,223.35l0.6,1.9h2c0.3,0,0.4,0.3,0.1,0.5l-1.6,1.2l0.6,1.9c0.1,0.3-0.2,0.4-0.4,0.3l-1.6-1.2 l-1.6,1.2c-0.2,0.1-0.5-0.1-0.4-0.3l0.6-1.9l-1.6-1.2c-0.2-0.1-0.1-0.4,0.1-0.5h2l0.6-1.9C235.9,223.05,236.3,223.05,236.4,223.35z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M295.9,184.55l0.8,2.4h2.5c0.3,0,0.4,0.4,0.2,0.6l-2,1.5l0.8,2.4c0.1,0.3-0.3,0.6-0.5,0.4l-2-1.4 l-2,1.4c-0.3,0.2-0.6-0.1-0.5-0.4l0.8-2.4l-2-1.5c-0.3-0.2-0.1-0.6,0.2-0.6h2.5l0.8-2.4C295.4,184.25,295.8,184.25,295.9,184.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M223.1,211.85l0.6,1.9h2c0.3,0,0.4,0.3,0.1,0.5l-1.6,1.2l0.6,1.9c0.1,0.3-0.2,0.4-0.4,0.3l-1.6-1.2 l-1.6,1.2c-0.2,0.1-0.5-0.1-0.4-0.3l0.6-1.9l-1.6-1.2c-0.2-0.1-0.1-0.4,0.1-0.5h2l0.6-1.9C222.7,211.55,223,211.55,223.1,211.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M232.7,238.35l1,2.8h3c0.4,0,0.6,0.5,0.3,0.7l-2.4,1.8l0.9,2.9c0.1,0.4-0.3,0.7-0.6,0.4l-2.4-1.7 l-2.4,1.7c-0.3,0.3-0.7-0.1-0.6-0.4l0.9-2.9l-2.4-1.8c-0.3-0.3-0.1-0.7,0.3-0.7h3l1-2.8C232.1,237.95,232.6,237.95,232.7,238.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M306.3,252.25l0.6,1.8h1.9c0.3,0,0.3,0.3,0.1,0.4l-1.5,1.1l0.6,1.8c0.1,0.3-0.2,0.4-0.4,0.3 l-1.5-1.1l-1.5,1.1c-0.2,0.1-0.4-0.1-0.4-0.3l0.6-1.8l-1.5-1.1c-0.2-0.1-0.1-0.4,0.1-0.4h1.9l0.6-1.8 C306,252.05,306.3,252.05,306.3,252.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M313,238.65l0.8,2.3h2.4c0.3,0,0.4,0.4,0.2,0.6l-1.9,1.4l0.7,2.3c0.1,0.3-0.3,0.6-0.5,0.4l-2-1.4 l-2,1.4c-0.3,0.2-0.6-0.1-0.5-0.4l0.7-2.3l-1.9-1.4c-0.3-0.2-0.1-0.6,0.2-0.6h2.4l0.8-2.3C312.4,238.35,312.9,238.35,313,238.65z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E3033"
    },
    d: "M19.1,488.15L19.1,488.15c-10.6,0-19.1-8.6-19.1-19.1V42.85c0-10.5,8.5-18.9,18.9-18.9H19 c10.6,0,19.1,8.6,19.1,19.1v426C38.3,479.55,29.7,488.15,19.1,488.15z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.1364a89992689e1f1996f19496fa5a78.svg";
export { ForwardRef as ReactComponent };